/**
 * Cliente API centralizado
 * TODOS los servicios deben usar este helper para garantizar URLs correctas
 */

import { API_URL } from '../config/api';
import { authFetch, authFetchJson } from '../services/authFetch';

/**
 * Construye una URL completa para una ruta API
 * @param {string} path - Ruta relativa (ej: '/usage/summary' o 'usage/summary')
 * @returns {string} URL completa
 */
export function buildApiUrl(path) {
    // Remover slash inicial si existe
    let cleanPath = path.startsWith('/') ? path.substring(1) : path;
    
    // Prevenir duplicidad api/api/
    if (cleanPath.startsWith('api/')) {
        cleanPath = cleanPath.substring(4);
    }
    
    // Si ya es una URL completa, devolverla
    if (cleanPath.startsWith('http://') || cleanPath.startsWith('https://')) {
        return cleanPath;
    }
    
    // Construir URL completa
    return `${API_URL}/${cleanPath}`;
}

/**
 * Helper para hacer fetch con URL correcta (devuelve Response crudo)
 * @param {string} path - Ruta relativa
 * @param {object} options - Opciones de fetch
 * @returns {Promise<Response>}
 */
export async function apiFetch(path, options = {}) {
    const url = buildApiUrl(path);
    return authFetch(url, options);
}

/**
 * Helper para hacer fetch con URL correcta (devuelve JSON parseado)
 * @param {string} path - Ruta relativa
 * @param {object} options - Opciones de fetch
 * @returns {Promise<any>}
 */
export async function apiFetchJson(path, options = {}) {
    const url = buildApiUrl(path);
    return authFetchJson(url, options);
}

export default {
    buildApiUrl,
    apiFetch,
    apiFetchJson
};
